module.exports = __webpack_public_path__ + "img/bg-camera-tablet-centered.1c7d691a.png";